import PayrollMainContent from "./PayrollContent";

export default PayrollMainContent;